// extracted by mini-css-extract-plugin
module.exports = {"body":"Form_body__QXbJQ","colEmail":"Form_colEmail__34q8E","modal":"Form_modal__1FNHS"};